export const LEARN_MORE_LINK =
	'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';

export const READ_ABOUT_CONFIGURING_STATUSES_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/configure-statuses-resolutions-and-priorities/';

export const UPGRADE_LINK = '/admin/billing/applications';
